module.exports = __webpack_public_path__ + "img/LUB00416.458a8209.png";